
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Plus } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { useClasses } from '@/api/classes';
import { Skeleton } from '@/components/ui/skeleton';
import { AddClassDialog } from '@/components/classes/add-class-dialog';
import { ClassCard } from '@/components/classes/class-card';
import { PageHeader } from '@/components/shared/page-header';

export default function ClassesPage() {
  const { t } = useTranslation();
  const [addClassOpen, setAddClassOpen] = useState(false);
  const { data: classes, isLoading } = useClasses();

  return (
    <div className="space-y-6">
      <PageHeader title={t('classes.title')}>
        <Button onClick={() => setAddClassOpen(true)} className="w-full sm:w-auto">
          <Plus className="h-4 w-4 mr-2" />
          {t('classes.addClass')}
        </Button>
      </PageHeader>

      {isLoading ? (
        <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
          {[1, 2, 3].map((i) => (
            <Card key={i}>
              <CardHeader>
                <Skeleton className="h-6 w-3/4" />
              </CardHeader>
              <CardContent>
                <Skeleton className="h-20 w-full" />
              </CardContent>
            </Card>
          ))}
        </div>
      ) : classes && classes.length > 0 ? (
        <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
          {classes.map((gymClass) => (
            <ClassCard key={gymClass._id} gymClass={gymClass} />
          ))}
        </div>
      ) : (
        <Card>
          <CardContent className="text-center py-12">
            <p className="text-muted-foreground">{t('classes.noClasses')}</p>
            <Button
              onClick={() => setAddClassOpen(true)}
              className="mt-4"
              variant="outline"
            >
              <Plus className="h-4 w-4 mr-2" />
              {t('classes.addClass')}
            </Button>
          </CardContent>
        </Card>
      )}

      <AddClassDialog open={addClassOpen} onOpenChange={setAddClassOpen} />
    </div>
  );
}
